// Replacement for https://lodash.com/docs/4.17.15#lowerFirst

export const lowerFirst = (value: string) => `${value.charAt(0).toLowerCase()}${value.slice(1)}`;
// Replacement for https://lodash.com/docs/4.17.15#lowerFirst

export const lowerFirst = (value: string) => `${value.charAt(0).toLowerCase()}${value.slice(1)}`;
